export enum LabelType {
    Regions = 'REGIONS',
    PracticeType = 'PRACTICE_TYPE',
    PricingTier = 'PRICING_TIER',
}
